import * as firebase from 'firebase';
import fbConfig from './config';

if (!firebase.apps.length) {
  firebase.initializeApp(fbConfig);
}

const auth = firebase.auth();
const db = firebase.database();

export { auth, db };



// WEBPACK FOOTER //
// ./src/firebase/firebase.js